import { apiUrl } from './../constants/apiUrl'
import api from '../service/apiService'
import { Utils } from '../util/utils'
import { logKafka, logOtherInfo, detailsInfo, catchJSException } from './../service/logService';
// import { errorAction } from './errorAction'
import { getVZDLInit } from './../service/vzdl';
import { store } from '../index';



let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;

export const getProductsFromJSON = (dispatch) => {
  var response = require('../containers/product/sampleProductsJson.json');
  dispatch({ type: 'PRODUCTSFROMJSON', value: response });
  dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
  return response;
}

export const getProductsFromApi = (request, dispatch, visitId,id) => {
  try {
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    document.getElementById("loader-alert").setAttribute("role", "alert")
    var selectedResponse;
    let paginationData;
    let selectedProdDescData;
    var proddata =window.prodresp;
    let reqParam = JSON.parse(request);
    let isSignedIn = (reqParam && reqParam['signedIn']);

    logOtherInfo(detailsInfo('ProductsPage', visitId, 'getProductsFromApi', "Inside getProductsFromApi"));
    const categoriesUrl = apiUrl().productsUrl;
    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    //if(proddata !== undefined && proddata !== "" && proddata !== null )
    if(proddata && !isSignedIn)
    {
      var response=proddata
      // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
        paginationData = { pagination: response.pagination, totalPageCount: response.totalPageCount, productCount: response.productCount, minProdCount: response.minProdCount, maxProdCount: response.maxProdCount, zeroProductsMessage:response.zeroProductsMessage }
        selectedProdDescData = { groupName: response.groupName, groupDesc: response.groupDescription, footerDescription: response.footerDescription }
        selectedResponse = response.products.map((object, index) => {
          return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
        })
        dispatch({ type: 'PRODUCTSFROMAPI', value: selectedResponse });
        dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
        dispatch({ type: 'PAGINATION', value: paginationData });
        dispatch({ type: 'SELECTEDCATEGORYDESC', value: selectedProdDescData });
        dispatch({ type: 'PRODUCTBANNER', value: response.prodBanner });
        window.prodresp=""
        document.getElementById("showing-products").setAttribute("role", "")
        document.getElementById("showing-products").setAttribute("role", "alert");
        if(id){
          document.getElementById(id).focus();
      }
    }else
    {api(categoriesUrl, 'POST', request).then(response => {
      window.scrollTo(0, 0);
      if (Utils.isNotNull(response)) {
       // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
        document.getElementById("loader-alert").setAttribute("role", "")
        paginationData = { pagination: response.pagination, totalPageCount: response.totalPageCount, productCount: response.productCount, minProdCount: response.minProdCount, maxProdCount: response.maxProdCount, zeroProductsMessage:response.zeroProductsMessage }
        selectedProdDescData = { groupName: response.groupName, groupDesc: response.groupDescription, footerDescription: response.footerDescription }
        selectedResponse = response.products.map((object, index) => {
          return { ...object, selectedProd: object.items[0], groupId: "G" + index, modifiedName: Utils.removeSpecialChars(object.name) }
        })
        dispatch({ type: 'PRODUCTSFROMAPI', value: selectedResponse });
        dispatch({ type: 'FILTERFROMJSON', value: response.filterBy });
        dispatch({ type: 'PAGINATION', value: paginationData });
        dispatch({ type: 'SELECTEDCATEGORYDESC', value: selectedProdDescData });
        dispatch({ type: 'PRODUCTBANNER', value: response.prodBanner });
        document.getElementById("showing-products").setAttribute("role", "")
        document.getElementById("showing-products").setAttribute("role", "alert")
        if(id){
          document.getElementById(id).focus();
        }

      }
      else {
        // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
      }
    }).catch(error => {
      let errorMsg = `MethodName:getProductsFromApi,errorMessage:${error.message}`;
      logKafka("ERROR", "ProductsPage", errorMsg, getErrorLogUrl, "applogs", visitId);
      // dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } })
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false, isLoaderText: "RESET_LOADER"}}); 
      getVZDLInit(visitId,"","","","","","",error.message);
    })}
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'getProductsFromApi', ex);
  }
}

export const addToCart = (request, dispatch) => {
  var response = require('../containers/Cart/sampleCartProductDetailsJson.json')
  dispatch({ type: 'CARTPRODUCTSDETAILSFROMJSON', value: response.data.prodAccessoryList, subTotal: response.data.Subtotal, total: response.data.Total, shippingcrg: response.data.Shippingcharge, tax: response.data.Tax });
  return request;
}

export const updatePromotionProducts = (categoriesUrl, request1, request2, visitId, dispatch) => {
  return new Promise((resolve, reject) => {
    api(categoriesUrl, 'POST', request1)
      .then((response) => {
        return api(categoriesUrl, 'POST', request2)
      })
      .then((response) => {
        dispatch({
          type: 'CARTPRODUCTSDETAILSFROMJSON',
          value: response.data.prodAccessoryList,
          subTotal: response.data.subTotal,
          total: response.data.total,
          shippingcrg: response.data.shippingCharge,
          tax: response.data.tax,
        });
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        resolve(response);
      })
      .catch((error) => {
        let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
        logKafka('ERROR', 'ProductsPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        getVZDLInit(visitId, '', '', '', '', '', '', error.message);
      });
  });
}


export const updateCart = (request, visitId, dispatch) => {
  try {
    logOtherInfo(detailsInfo('ProductsPage', visitId, 'updateCart', "Inside updateCart"))
    let categoriesState = store && store.getState() && store.getState().categoriesVTP ? store.getState().categoriesVTP : "";
    let req = JSON.parse(request)
    if (categoriesState?.holidayOfferCall) {
      if (categoriesState?.holidayOfferProducts.includes(req.productId)) {
        req["mlpFlow"] = true
        request = JSON.stringify(req)
      }
    }
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Updating your cart" } });
    const categoriesUrl = apiUrl().updateCart + "/" + visitId;
    //for remove and update cart for promotion cases
    let cartState = store && store.getState() && store.getState().cartProductDataVTP ? store.getState().cartProductDataVTP : "";
    let promoProduct = cartState?.cartProduct?.find(obj => obj.pppId === req.productId && (obj.promoId !== null && obj.promoId !== "" && obj.promoId !== undefined))
    if (cartState?.cartProduct.length > 0 && promoProduct && !(req.status == "remove" && req.promoId != null)) {
      const baseRequest = { ...req, quantity: 1 };
      let request1, request2;
      if (req.status === "add") {
        request1 = JSON.stringify({ ...baseRequest, status: "remove" })
        request2 = JSON.stringify({ ...baseRequest, promoId: promoProduct.promoId, quantity: req.quantity });
        return updatePromotionProducts(categoriesUrl, request1, request2, visitId, dispatch)
      }
      else if (req.status === "remove") {
        request1 = request;
        request2 = JSON.stringify({ ...baseRequest, promoId: promoProduct.promoId, status: "add" })
        return updatePromotionProducts(categoriesUrl, request1, request2, visitId, dispatch)
      }
    }
    else {
      return new Promise((resolve, reject) => {
        api(categoriesUrl, 'POST', request)
          .then((response) => {
            dispatch({
              type: 'CARTPRODUCTSDETAILSFROMJSON',
              value: response.data.prodAccessoryList,
              subTotal: response.data.subTotal,
              total: response.data.total,
              shippingcrg: response.data.shippingCharge,
              tax: response.data.tax,
            });
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            dispatch({ type: 'ROUNDUPCHARITYADDED', value: false });
            dispatch({ type: 'SELECTEDCHARITY', value: "" });
            resolve(response);
          })
          .catch((error) => {
            let errorMsg = `MethodName:updateCart,errorMessage:${error.message}`;
            logKafka('ERROR', 'ProductsPage', errorMsg, getErrorLogUrl, 'applogs', visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            getVZDLInit(visitId, '', '', '', '', '', '', error.message);
          });
      });
    }
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'updateCart', ex);
  }
};


export const getPageinfoByName = (request, dispatch, visitId) => {
  try{
    var bannerData=window.bannerresp
    logOtherInfo(detailsInfo('ProductsPage', visitId, 'getPageinfoByName', "Inside getPageinfoByName"))
    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true, isLoaderText: "Just a moment, we're looking it up now." } });
    const bannerUrl = apiUrl().bannerUrl;
    if (bannerData !== undefined && bannerData !== "" && bannerData !== null && (bannerData.categoryId !== undefined && bannerData.categoryId !== null && bannerData.categoryId !== "") )
    {
      dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
      bannerStatus(true,dispatch);
      dispatch({ type: 'PAGEINFO', value: bannerData });
      window.bannerresp="";
      return bannerData;
    }
    else{
    return new Promise((resolve, reject) => {
      api(bannerUrl, 'POST', request).then(response => {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        if (Utils.isNotNull(response) && response.categoryId !== undefined && response.categoryId !== null && response.categoryId !== "") {
          bannerStatus(true,dispatch); /** setting banner call status which used in wrapper product to render error page */
          dispatch({ type: 'PAGEINFO', value: response });
          // let request = {
          //   "categoryId": response.categoryId,
          //   "productId": response.productId
          // }
         // dispatch({ type: 'STOREPRODUCTID', value: request });
          resolve(response);
        }else{
          bannerStatus(false,dispatch);
          dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
       
          /**will render 404 content if banner returns null */
          // errorAction("404", "Product", "Product", "applogs", visitId, dispatch, true, "ProductsFetchFailed");
        }
      }).catch(error => {
        let errorMsg = `MethodName:getPageinfoByName,errorMessage:${error.message}`;
      logKafka("ERROR", "ProductsPage", errorMsg, getErrorLogUrl, "applogs", visitId);
              dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
              getVZDLInit(visitId,"","","","","","",error.message);
      })
  
    })}  
  } catch (ex) {
    catchJSException('ProductsPage', visitId, 'getPageinfoByName', ex);
  }
  }
  export const bannerStatus = (request, dispatch) => {
    dispatch({ type: 'BANNERSTATUS', value: request });
  }
export const productValue = (request, dispatch) => {
  dispatch({ type: 'PRODUCTSFROMAPI', value: request });
}
export const emptyPageinfo = (dispatch) => {
  dispatch({ type: 'PAGEINFO', value: "" });
}
export const setSelectedProduct = (selectedProd, dispatch) => {
  dispatch({ type: 'SELECTEDPROD', value: selectedProd });
}
export const setFilterData = (dispatch, request) => {
  dispatch({ type: 'SETFILTERDATA', value: request });
}
export const clearFilterData = (dispatch, request) => {
  dispatch({ type: 'CLEARFILTERDATA', value: request });
}
export const onClear = (dispatch) => {
  dispatch({ type: 'DESTROY_SESSION' });
};
export const setFilterFlag = (dispatch, filterVal) => {
  dispatch({ type: 'FILTERFLAG',value: filterVal});
};